<div class="about-us-home">
  <!-- Section 1: About (Left) and Image (Right) -->
  <div class="about-us-home--section">
    <app-about></app-about>
  </div>

  <!-- Section 6: Key Platform Features -->
  <div class="about-us-home--section">
    <app-key-platform-features></app-key-platform-features>
  </div>

  <!-- Footer -->
  <app-footer></app-footer>
</div>

